"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_PERIODS = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Input_1 = __importDefault(require("@material-ui/core/Input"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var raffle_service_1 = require("@pbl/pbl-react-core/lib/services/raffle-service");
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var RaffleWinnings_1 = __importDefault(require("./RaffleWinnings"));
var ErrorMessages_1 = __importDefault(require("./v3/ErrorMessages"));
var styles_1 = require("./v3/styles");
exports.TIME_PERIODS = [
    {
        value: 'mostRecent'
    }
];
var RaffleNumbersCheck = function (_a) {
    var selectedGame = _a.selectedGame, theme = _a.theme, scrollToRef = _a.scrollToRef, _b = _a.isNewVersion, isNewVersion = _b === void 0 ? false : _b;
    var classes = (0, styles_1.styles)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = (0, react_1.useState)(['']), tickets = _c[0], setTickets = _c[1];
    var _d = (0, react_1.useState)(null), winningResults = _d[0], setWinningResults = _d[1];
    var _e = (0, react_1.useState)([]), errors = _e[0], setErrors = _e[1];
    var _f = (0, react_1.useState)(''), responseError = _f[0], setResponseError = _f[1];
    var checkNumbers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var inputErrors, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    inputErrors = [];
                    tickets.forEach(function (ticket, index) {
                        if (ticket.length === 0) {
                            var blankError = {
                                key: index,
                                value: 'Ticket number cannot be blank.'
                            };
                            inputErrors.push(blankError);
                        }
                    });
                    setErrors(inputErrors);
                    if (Object.keys(inputErrors).length > 0) {
                        setResponseError('');
                        setWinningResults(null);
                        return [2];
                    }
                    return [4, raffle_service_1.RaffleService.getWinningNumbers(selectedGame.id, (0, moment_1.default)(selectedGame.startDate).format('YYYY-MM-DD'), tickets.map(function (ticket) { return Number(ticket); }))];
                case 1:
                    response = _b.sent();
                    if (response.message) {
                        setResponseError(((_a = response === null || response === void 0 ? void 0 : response.payload) === null || _a === void 0 ? void 0 : _a.detail) || response.message);
                        setWinningResults(null);
                        return [2];
                    }
                    setWinningResults(tickets.map(function (ticket) {
                        var result = response.find(function (item) { return item.playersTicket === Number(ticket); });
                        if (result) {
                            return result;
                        }
                        return {
                            playersTicket: ticket,
                            winningAmount: 0,
                            winningAmountHumanReadable: '$0'
                        };
                    }));
                    setTickets(__spreadArray([], tickets, true));
                    setErrors([]);
                    return [2];
            }
        });
    }); };
    var updateTicket = function (updatedTicket, selectedTicketIndex) {
        if (isNaN(Number(updatedTicket)) || updatedTicket.length > 6) {
            return;
        }
        var newTickets = __spreadArray([], tickets, true);
        newTickets[selectedTicketIndex] = updatedTicket;
        setTickets(newTickets);
    };
    var addTicket = function () {
        setTickets(__spreadArray(__spreadArray([], tickets, true), [''], false));
    };
    var information = [];
    var generateInfoMessage = function () {
        information.push("Up to 10 tickets can be added.");
        information.push("The ticket length can be between 1 to 6.");
        return (react_1.default.createElement("ul", null, information.map(function (item, index) { return (react_1.default.createElement("li", { key: index }, item)); })));
    };
    return (react_1.default.createElement("div", { className: classes.numbersContainer + isNewVersion ? ' nobgContainer' : '', ref: scrollToRef },
        react_1.default.createElement("section", { className: classes.formContainer },
            react_1.default.createElement(Typography_1.default, { variant: "h2", className: classes.sectionTitle }, "".concat(t('numberChecker.check'), " ").concat(selectedGame.name, " ").concat(t('numberChecker.numbers'))),
            react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.captionTxt }, t('numberChecker.required')),
            react_1.default.createElement(FormControl_1.default, { fullWidth: true },
                react_1.default.createElement(Typography_1.default, { variant: 'body1', className: classes.inputLabel }, t('numberChecker.selectDate')),
                react_1.default.createElement(InputLabel_1.default, { className: classes.selectInputLabel, htmlFor: "date-select" }, t('numberChecker.drawingDate', 'Drawing date')),
                react_1.default.createElement(Select_1.default, { id: "date-select", className: classes.formInput, value: exports.TIME_PERIODS[0].value, disabled: exports.TIME_PERIODS.length === 1, autoComplete: "off" }, exports.TIME_PERIODS.map(function (item) { return (react_1.default.createElement(MenuItem_1.default, { key: item.value, value: item.value }, t("numberChecker.".concat(item.value)))); }))),
            react_1.default.createElement(Typography_1.default, { variant: 'body1', className: classes.inputLabel }, t('numberChecker.ticketNumbers')),
            generateInfoMessage(),
            tickets.map(function (ticket, index) {
                var onUpdate = function (event) { return updateTicket(event.target.value, index); };
                var hasError = errors.find(function (e) { return e.key === index; });
                return (react_1.default.createElement(FormControl_1.default, { fullWidth: true, key: "".concat(index + 1) },
                    react_1.default.createElement(Typography_1.default, { variant: "body2", component: "span", className: classes.inputLabel }, "Ticket ".concat(index + 1, " Numbers")),
                    react_1.default.createElement(InputLabel_1.default, { shrink: false, className: hasError ? classes.indexLabelError : classes.indexLabelUpdated, htmlFor: "ticket-input".concat(index + 1) },
                        react_1.default.createElement(Typography_1.default, { variant: 'srOnly' }, "Ticket ".concat(index + 1, ", ")),
                        'Ticket Number*'),
                    react_1.default.createElement(Input_1.default, { id: "ticket-input".concat(index + 1), className: (0, classnames_1.default)([
                            classes.numberInput,
                            classes.raffleInput,
                            hasError ? classes.numberErrorInput : undefined
                        ]), value: ticket != null ? ticket.toString() : '', key: "".concat(index + 1), onChange: onUpdate, classes: { input: classes.centerText }, autoComplete: 'off', inputProps: {
                            'aria-required': true
                        } }),
                    react_1.default.createElement("div", { "aria-live": "polite", "aria-atomic": true },
                        react_1.default.createElement(ErrorMessages_1.default, { theme: theme, errors: responseError.length > 0
                                ? [{ value: String(responseError) }]
                                : errors.filter(function (e) { return e.key === index; }) }))));
            }),
            react_1.default.createElement(Grid_1.default, { className: classes.configContainer },
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)([
                        classes.buttonOutline,
                        tickets.length === 10 ? classes.btnDisabled : ''
                    ]), disabled: tickets.length === 10, size: "medium", variant: "outlined", color: "primary", disableElevation: true, onClick: addTicket },
                    react_1.default.createElement(Typography_1.default, { variant: "button", className: classes.addTicketButton }, t('numberChecker.addTicket'))),
                react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.ticketCount },
                    tickets.length,
                    " of 10 Tickets Added")),
            react_1.default.createElement(Grid_1.default, { className: classes.btnContainer },
                react_1.default.createElement(Button_1.default, { key: 'button', className: (0, classnames_1.default)([classes.button, classes.checkBtn]), onClick: checkNumbers, size: "medium", variant: "contained", color: "secondary", disableElevation: true },
                    react_1.default.createElement(Typography_1.default, { variant: "button" }, t("numberChecker.".concat(winningResults || errors.length > 0 ? 'checkAgain' : 'checkNumbers'))))),
            winningResults && react_1.default.createElement(RaffleWinnings_1.default, { theme: theme, winningResults: winningResults }))));
};
exports.default = RaffleNumbersCheck;
//# sourceMappingURL=RaffleNumbersCheck.js.map